export default {
	name: "ToolbarActionableMixin",

	props: {
		showToolbarActions: {
			default: true,
			type: Boolean
		}
	},

	data: () => ( {
		actionsAddedFromHere: []
	} ),

	computed: {
		actionsAddedFromHereKeys() {
			if ( this.actionsAddedFromHere ) {
				return this.actionsAddedFromHere.map( action => action.text );
			}

			return [];
		},

		toolbarActionsArr() {
			return [].concat( this.toolbarActions || [] );
		},

		storeToolbarActions() {
			return this.$store.state.toolbarActions.items;
		},

		storeToolbarActionsKeys() {
			if ( this.storeToolbarActions ) {
				return this.storeToolbarActions.map( action => action.text );
			}

			return [];
		},

		toolbarActionsKeys() {
			if ( this.toolbarActions ) {
				const toolbarActions = [].concat( this.toolbarActions || [] );

				return toolbarActions.map( action => action.text );
			}

			return [];
		},

		newActions() {
			if ( this.toolbarActions ) {
				return this.toolbarActionsArr.filter( action =>
					this.storeToolbarActionsKeys.indexOf( action.text ) === -1
				);
			}
		},

		oldActions() {
			if ( this.actionsAddedFromHereKeys ) {
				return this.actionsAddedFromHere.filter( action => {
					const thisIndex = this.toolbarActionsKeys.indexOf( action.text );
					const storeIndex = this.storeToolbarActionsKeys.indexOf( action.text );

					return thisIndex === -1 && storeIndex !== -1;
				} );
			}
		}
	},

	watch: {
		newActions: {
			handler( newActions ) {
				if ( this.showToolbarActions && newActions && newActions.length ) {
					this.$store.dispatch( "toolbarActions/add", newActions );

					newActions.forEach( action => this.actionsAddedFromHere.push( action ) );
				}
			},
			immediate: true
		},

		oldActions: {
			handler( oldActions ) {
				if ( oldActions && oldActions.length ) {
					this.$store.dispatch( "toolbarActions/remove", oldActions );

					oldActions.forEach( oldAction => {
						this.actionsAddedFromHere.splice(
							this.actionsAddedFromHereKeys.indexOf( oldAction.text ),
							1
						);
					} );
				}
			},
			immediate: true
		}
	},

	beforeDestroy() {
		this.$store.dispatch( "toolbarActions/remove", this.actionsAddedFromHere );
	}
};
